<template>
    <form @submit.prevent="Store">
        <slot />
    </form>
</template>

<script>
export default {
    data() {
        return {
            isReset: false,
            isSubmit: false,
            stages: {},
            validateErrors: {},
            formdata: new FormData()
        }
    },
    methods: {
        registerToStage(name, value = null) {
            this.stages[name] = value
        },
        pushValidateError(name, value = null) {
            this.validateErrors[name] = value
        },
        reset() {
            this.isReset = true
            setTimeout(() => {
                this.isReset = false
            }, 500);
        },
        Store() {
            this.isSubmit = true

            this.$nextTick(() => {
                if ( Object.keys(this.validateErrors).filter(key => this.validateErrors[key]).length ) {
                        console.error('Validate fails')
                        return
                } else {
                    let stages = this.stages
                    Object.keys(stages).forEach(key => {
                        if ( stages[key] ) {
                            this.formdata.append(key, stages[key])
                        }
                    })

                    this.$emit('onSubmit', {
                        formdata: this.formdata,
                        reset: () => {
                            this.isReset = true
                            setTimeout(() => {
                                this.isReset = false
                            }, 500);
                        }
                    })
                }

            })
        }
    }

}
</script>